import {Component} from '@angular/core';

@Component({
    selector: 'app-companies-settings-skeleton',
    templateUrl: './companies-settings-skeleton.component.html',
    styles: [':host { display: block; }']
})
export class CompaniesSettingsSkeletonComponent {
    readonly cardPlaceholders = [0, 1, 2, 3];
    readonly fieldPlaceholders = [0, 1, 2, 3];
}
